// AppShell: the two-region frame every app starts from. Desktop = sidebar +
// main content; under 768px the sidebar is replaced by the bottom nav. Widths
// are a grid track so the collapse animation never reflows the main content.

import type { ReactNode } from 'react'
import { Sidebar } from './Sidebar'
import { BottomNav } from './BottomNav'
import type { NavItem } from './types'
import css from './AppShell.module.css'

export type AppShellProps = {
  /** Brand area content shown in the sidebar. */
  brand?: ReactNode
  items: NavItem[]
  activeId: string
  onSelect: (id: string) => void
  /** Collapses the sidebar to an icon rail on desktop. */
  sidebarCollapsed?: boolean
  /** Renders the sidebar collapse toggle when supplied. */
  onToggleSidebar?: () => void
  /** Pinned sidebar footer. */
  sidebarFooter?: ReactNode
  children: ReactNode
}

/**
 * Render the application frame.
 * @param props - nav config and the main content.
 * @returns the shell element with sidebar (desktop) or bottom nav (mobile).
 */
export function AppShell({
  brand,
  items,
  activeId,
  onSelect,
  sidebarCollapsed = false,
  onToggleSidebar,
  sidebarFooter,
  children,
}: AppShellProps) {
  return (
    <div className={css.shell} data-collapsed={sidebarCollapsed || undefined}>
      <Sidebar
        className={css.sidebar}
        brand={brand}
        items={items}
        activeId={activeId}
        onSelect={onSelect}
        collapsed={sidebarCollapsed}
        onToggleCollapse={onToggleSidebar}
        footer={sidebarFooter}
      />
      <main className={css.main}>{children}</main>
      <BottomNav className={css.bottomNav} items={items} activeId={activeId} onSelect={onSelect} />
    </div>
  )
}
